import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FormOutlined, EyeOutlined } from '@ant-design/icons';
import { Table, Row, Col, Breadcrumb, Typography, Tooltip } from 'antd';
import { intialPaginationState, filter, unexpectedError, showingPageTotalRange } from '../../../common_functions';

const MountTypes = props => {
  const [mount, setMount] = useState([]);
  const [pagination, setPagination] = useState(intialPaginationState);
  const [sorter, setSorter] = useState(null);
  const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'id',
      key: 'id',
      width: '10%',
      render: (value, item, index) => {
        return (pagination.current - 1) * pagination.pageSize + index + 1;
      },
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true,
      ...filter('name'),
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => (
        <span>
          <div className="actionbtngroup">
            <Link to={'/settings/mount-conditions/' + record.id}>
              <Tooltip
                placement="top"
                title={props.roleType === 'admin' || props?.tabs_permissions?.settings_mount_conditions?.edit ? 'Edit' : 'View'}
              >
                <button className="edit-btn">
                  {props.roleType === 'admin' || props?.tabs_permissions?.settings_mount_conditions?.edit ? (
                    <FormOutlined />
                  ) : (
                    <EyeOutlined />
                  )}
                </button>
              </Tooltip>
            </Link>
            {props.deleteRecord(
              props,
              record.id,
              'mount_type',
              'Mount condition?',
              mount,
              setMount,
              props?.tabs_permissions?.settings_mount_conditions?.delete
            )}
          </div>
        </span>
      ),
    },
  ];
  //Get collection data
  useEffect(() => {
    (async () => {
    await getMountData(pagination);
  })();
  }, []);

  const getMountData = async (pagination, filters = {}, sorter = '') => {
    setLoading(true);
    try {
      const response = await props.getItems('mount_type', {
        fields: ['id', 'name'],
        sort: !!sorter && sorter.field ? (sorter.order === 'ascend' ? '' : '-') + sorter.field : '-id',
        filters: filters,
        offset: pagination.pageSize * (pagination.current - 1),
        limit: pagination.pageSize,
        meta: 'filter_count',
      });
      pagination.total = response.meta.filter_count;
      setPagination(pagination);
      setMount(response.data);
    } catch (error) {
      unexpectedError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = async (pagination, filters, sorter) => {
    setPagination(pagination);
    setSorter(sorter);
    setLoading(true);
    let filtersitems = {};
    for (let key in filters) {
      if (filters.hasOwnProperty(key)) {
        let val = filters[key];
        val && (key == 'id' ? (filtersitems[key] = { _eq: val[0] }) : (filtersitems[key] = { _icontains: val[0] }));
      }
    }
    await getMountData(pagination, filtersitems, sorter);
  };
  return (
    <Row>
      <Col span={24} className="app-breadcrumb-col">
        <Breadcrumb items={[{ title: "Settings", href: "/settings/mount-conditions" }, { title: "Mount Conditions" }]} />
      </Col>
      <Col className="white-paper" span={24}>
        <div className="dashboard">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                View Mount Conditions
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end">
              {props.createButton(
                props.roleType,
                props.tabs_permissions.settings_mount_conditions,
                '/settings/mount-conditions/new',
                ' Create Mount Conditions'
              )}
            </Col>
          </Row>
          <hr />
          <div className="artist-list">
            <Table
              className="fill-table-width"
              scroll={{ x: 'max-content' }}
              columns={columns}
              bordered
              rowKey={record => record.id}
              dataSource={mount}
              pagination={{ ...pagination, ...showingPageTotalRange }}
              loading={loading}
              onChange={handleTableChange}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default MountTypes;
